import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { NgbDatepickerModule, NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'

import { UtilCommonModule } from 'common/util'
import { EntityListModule } from 'common/entityList'
import { LocaleModule } from 'common/locale'
import { LuxonDateTimeModule } from 'common/luxonDateTime'
import { MediaPermissionsModule } from 'media.permissions'

import { SharedLinkComponent } from './components/sharedLink.component'
import { SharingLinksReadyModalComponent } from './components/sharingLinksReadyModal.component'
import { SharingModalComponent } from './components/sharingModal.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    EntityListModule,
    UtilCommonModule,
    LuxonDateTimeModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgbDatepickerModule,
    LocaleModule.forChild(),
    MediaPermissionsModule,
    SharedLinkComponent,
    SharingModalComponent,
    SharingLinksReadyModalComponent,
  ],
  exports: [
    SharedLinkComponent,
  ],
})
export class MediaSharingModule { }

export { MediaShareTaskParamsComponent } from './components/mediaShareTaskParams.component'
